export * from './patient-infectious.service';